module.exports = __webpack_public_path__ + "images/emoji/mag.bfd93e2fff767e408bb9.png";